export default "__VITE_ASSET__D8tta1t3__"